module.exports = __webpack_public_path__ + "static/media/MoreIcon_hover.0659c817.svg";